import styled from 'styled-components';

export const ProductContainer = styled.div`
  position: relative;
  margin: 10px 0 30px;

  @media (max-width: 720px) {
    margin: 10px 10px 30px;
  }
`;

export const BabyNamesArticleHeading = styled.h4`
  color: rgba(0, 0, 0, 0.8);
  padding: 14px 0px 0;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  font-size: clamp(15px, 2vw, 18px);
`;
